import { typographyToCss } from 'shared/lib/mui';
import { QueryNavLink } from 'shared/lib/react-router-dom';
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;

  height: 100dvh;
  width: 100vw;

  background: ${({ theme }) => theme.palette.background.default};
`;

export const Content = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;

  padding: ${({ theme }) => theme.spacing(6)};
`;

export const Body = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;

  margin: 0 auto;
  max-width: 100%;
`;

export const BodyContent = styled.div`
  flex-shrink: 1;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(6)};

  min-width: 0;
  width: 32rem;
  max-width: 32rem;
`;

export const Footer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(6)};
`;

export const Divider = styled.span`
  display: block;

  width: 100%;
  height: 1px;

  background: ${({ theme }) => theme.palette.divider};
`;

export const Anchor = styled(QueryNavLink)`
  color: ${({ theme }) => theme.palette.primary.main};
`;

export const TermsOfUse = styled.p`
  ${({ theme }) => typographyToCss(theme.typography.overline)};

  margin: 0;
  padding: 0;

  color: ${({ theme }) => theme.palette.text.secondary};
  text-align: center;
`;

export const ExternalAnchor = styled.a`
  color: inherit;
`;

export const IllustrationContainer = styled.div`
  display: none;
  flex: 1;
  position: relative;
  background: linear-gradient(90deg, #fae4ce 0%, #ecdbfe 100%);
  overflow: hidden;

  ${({ theme }) => theme.breakpoints.up(theme.breakpoints.values.md)} {
    display: block;
  }
`;

export const Illustration = styled.img`
  position: absolute;
  left: 20%;
  top: 50%;

  height: 80%;

  transform: translateY(-50%);
`;
